import {Component, HostBinding, Input} from '@angular/core';
import {Message} from '@catui/components/alert/types';

const componentBaseName = 'alerts';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-alerts',
  styleUrls: ['./alerts.component.scss'],
  templateUrl: './alerts.component.html',
})
export class AlertsComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() messages: Message[];

  constructor() { }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/alerts/alerts.component.ts